
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap';
import imageOnTheWay from '../../../../public/assets/images/imageOnTheWay.webp';
import Counter from './Counter.jsx'
import CountdownTimer from './CountdownTimer'
import Switch from '@mui/material/Switch';
import { getBidAmountDetail, getPreviousBidDetails, getautobidAmount, isAvailableBackUpBidAmount } from "@/api/bidDepositApiHold";
import { FaPlus } from "react-icons/fa6";
import Divider from '@mui/material/Divider';
import { SiTicktick } from "react-icons/si";
import { LiaBedSolid } from "react-icons/lia";
import { LuBath } from "react-icons/lu";
import { BiRuler } from "react-icons/bi";
import { getDHM } from "@/utils/dhmCalculation";
import { submitBid, getBidContingency } from "@/api/bids";
import { use } from 'react';
import { useNavigate } from "react-router";
import { doc, onSnapshot, collection } from "firebase/firestore";
import { inititaliseFirebase, deattachListeners } from "@/components/common/FirebaseApp";
import { store } from "@/store/store";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { getDatabase, ref, onValue, onChildAdded, onChildChanged, onChildRemoved } from "firebase/database";
import { IoMdClose } from "react-icons/io";
import { FaHeart } from "react-icons/fa6";
import { getBidCenterDetails, getPDPInitData } from "@/api/PDP";
import {
    fetchPDPBidCenterDataSuccess,
    fetchPDPInitialLoadSuccess,
    setSelectedBidAmount,
    fetchPDPLatestBidCenterData,
} from "@/redux/PDP/pdpSlice";
import { setListingId } from "@/bidFeature/propertyDetailSlice";
import { getAlertData, resetMessageCount } from "@/api/alerts";
import {
    setIsOtpVerificationModalRequired,
    setIsUserSubscribed,
    setSubscribeEmailAlreadyExists,
} from "@/redux/login/loginSlice";
import { isPhoneNoVerified } from "@/api/bid";

import { sendVerificationCode } from "@/api/LoginSignup";
import { showOtpModal } from "@/redux/otpModal/otpModalSlice";
import {

    getCMS,

} from "@/api/PDP";
import { MdErrorOutline } from "react-icons/md";
import {
    setAlerts,
    setAlertsCount,
    setProfileInfo,
    setFirebaseConfig,
} from "@/redux/user/userSlice";

import LoadingText from "@/components/loader/LoadingText.jsx";
import LoadedText from "@/components/loader/LoadedText.jsx";
import { globalCmsData } from "@/redux/cms/cmsSelectors";

const styles = {
    container: {
        backgroundColor: '#FDF6DC ',
        borderRadius: '10px',
        padding: '10px',
        margin: "0px",
        textAlign: 'center',
        width: '100%',
        //   boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    },
    text: {
        fontSize: '13px',
        fontWeight: "bold",
        textAlign: "left",
        marginBottom: '15px',
    },
    smallText: {
        fontSize: '12px',
        textAlign: "left",
        paddingTop: 10,
    },

};
import { isValidSession } from "@/api/auth";
import { getEventCategory, trackApiCall, trackButtonClick, trackEvent, trackPageMount } from '@/utils/analytics';
import { navigateToProperty } from '@/utils/propertyNavigation';
import { markInternalNavigation } from '@/utils/attributionCapture';
import { getPropertyType } from '@/utils/propCategory';

const AlertsCards = (item) => {
    const newErrors = {};
    const dispatch = useDispatch();

    const [isAutoBidEnabled, setAutoBidEnabled] = useState(false);
    const [buyerAmountInfo, setBuyerAmountInfo] = useState({});
    const [autobidAmountInfo, setAutobidAmountInfo] = useState({});

    const [amount, setAmount] = useState(item?.bidCenterAlertDetails?.nextpossibleBidAmount);
    const [validationError, setvalidationError] = useState("");
    const [autoBidValidationError, setAutoBidValidationError] = useState("");

    const [autoBidAmount, setAutoBidAmount] = useState(autobidAmountInfo?.bidAmount);
    const [viewDetailsTapped, setViewDetailsTapped] = useState(false);
    const [previousBidDetails, setPreviousBidDetails] = useState();
    const [showSuccess, setShowSuccess] = useState(false);
    const [successType, setSuccessType] = useState(null);
    const [endTheAuctionNowTapped, setEndtheAuctionNow] = useState(false)
    const [ownItNowEnabled, setOwnItNowEnabled] = useState(item?.specialFeatures?.length > 0 && item?.specialFeatures[0] === 'OWN_IT_NOW_ENABLED' ? true : false)
    const [endNowAmount,setEndNowAmount] = useState(item?.buyItNowPrice)

    const [bidIncrementCount, setBidIncrementCount] = useState(Number(0));
    const [auctionDetails, setAuctionDetails] = useState();
    const [bidContingency, setBidContingency] = useState()
    const [bidErrorMessage, setBidErrorMessage] = useState("");
    const bidCenterDetails = item.bidCenterAlertDetails;
    const state = store.getState();
    const userID = state?.user?.user?.realbidUserId;
    const firebaseConfig = useSelector((state) => state.user.firebaseConfig);
    const [hideDisplayMessage, setHideDisplayMessage] = useState(false);
    const [amountInfoMessage, setAmountInfoMessage] = useState("");
    const [maxBackUpBidLimit, setMaxBackUpBidLimit] = useState("");
    const [minBackUpBidLimit, setMinBackUpBidLimit] = useState("");
    const [incrementMultplier, setIncrementMultplier] = useState("");
    const [backupBidErrorCode, setBackupBidErrorCode] = useState("");
    const [firstTime, setFirtTime] = useState(true);
    const [cmsErrorMessages, setCmsErrorMessages] = useState();
    const [backupDuration, setBackupDuration] = useState("");
    const [shouldShowError, setShouldShowError] = useState(false);
    const selectedAlert = useSelector((state) => state?.user?.selectedAlert);
    const [activeConfigData, setActiveConfigData] = useState([]);
    const [isProcessing, setIsProcessing] = useState(false);

    const [isVerificationGoing, setIsVerificationGoing] = useState(false);
    const [isVerificationGoingForOwnitNow, setIsVerificationGoingForOwnitNow] =
        useState(false);

    const messageId = item?.messageId?.trim();
    const selectedMessageId = selectedAlert?.messageId?.trim();
    const profileInfo = useSelector((state) => state.user.user);


    const [placeBidTapped, setPlaceBidTapped] = useState((item?.messageId === undefined || item?.messageId === null) ? false : selectedMessageId?.trim() === messageId?.trim());
    const globalData = useSelector(globalCmsData);



    const userEmail = state?.user?.user?.userEmailId;
    // const userId = userProfileData?.userDetails?.userId;

    const [formattedMaxBackUpBidLimit, setFormattedMaxBackUpBidLimit] =
        useState("");
    const [formattedMinBackUpBidLimit, setFormattedMinBackUpBidLimit] =
        useState("");

    const until = bidCenterDetails?.auctionTimeLeft / 1000;
    const currentDate = new Date();
    const futureDate = new Date();
    const navigate = useNavigate();


    futureDate.setDate(currentDate.getDate() + parseInt(until / (60 * 60 * 24), 10))
    futureDate.setHours(currentDate.getHours() + parseInt(until / (60 * 60), 10) % 24)
    futureDate.setMinutes(currentDate.getMinutes() + parseInt(until / 60, 10) % 60)
    futureDate.setSeconds(currentDate.getSeconds() + until % 60)


    let nextpossibleBidAmount = 0;
    let biddingIncrementalAmount = 0;
    let incrementMultiplier = 0;
    let maximumPossibleBidAmount = 0;
    let bidMinLimit = 0;
    let bidMaxLimit = 0;
    let bidMaxLength = 0;
    let lowerThresholdAmount = 0;
    let lowerThresholdIncrementMultiplier = 0;
    let upperThresholdAmount = 0;
    let upperThresholdIncrementMultiplier = 0;
    let offerMinLimit = 0;
    let offerMaxLimit = 0;
    if (bidCenterDetails) {
        biddingIncrementalAmount = bidCenterDetails?.biddingIncrementalAmount;
        incrementMultiplier = bidCenterDetails?.incrementMultiplier;
        maximumPossibleBidAmount = bidCenterDetails?.maximumPossibleBidAmount;
        nextpossibleBidAmount = bidCenterDetails?.nextpossibleBidAmount;
        lowerThresholdAmount = bidCenterDetails?.lowerThresholdAmount;
        upperThresholdAmount = bidCenterDetails?.upperThresholdAmount;
        lowerThresholdIncrementMultiplier =
            bidCenterDetails?.lowerThresholdIncrementMultiplier;
        upperThresholdIncrementMultiplier =
            bidCenterDetails.upperThresholdIncrementMultiplier;
        if (
            bidCenterDetails?.currentHighestBid >= upperThresholdAmount &&
            bidCenterDetails?.activeBidRefinementEnabled === true
        ) {
            bidMinLimit =
                bidCenterDetails?.currentHighestBid + upperThresholdIncrementMultiplier;
        } else if (
            bidCenterDetails?.currentHighestBid >= lowerThresholdAmount &&
            bidCenterDetails?.activeBidRefinementEnabled === true
        ) {
            bidMinLimit =
                bidCenterDetails?.currentHighestBid + lowerThresholdIncrementMultiplier;
        } else if (
            bidCenterDetails?.nextpossibleBidAmount &&
            bidCenterDetails?.nextpossibleBidAmount > 0
        ) {
            bidMinLimit = bidCenterDetails?.nextpossibleBidAmount;
        } else {
            bidMinLimit = bidCenterDetails?.currentHighestBid + biddingIncrementalAmount;
        }

        if (
            bidCenterDetails?.maximumPossibleBidAmount &&
            bidCenterDetails?.maximumPossibleBidAmount > 0
        ) {
            bidMaxLimit =
                bidCenterDetails?.activeBidRefinementEnabled === true &&
                    nextpossibleBidAmount <= lowerThresholdAmount
                    ? lowerThresholdAmount
                    : bidCenterDetails?.maximumPossibleBidAmount;
        }
    }

    bidMaxLength = (bidMaxLimit + " ").length + 1;

    const lowerSlab =
        lowerThresholdAmount > bidCenterDetails?.currentHighestBid
            ? lowerThresholdAmount
            : bidCenterDetails?.currentHighestBid + lowerThresholdIncrementMultiplier;

    const upperSlab =
        upperThresholdAmount >= bidCenterDetails?.nextpossibleBidAmount
            ? upperThresholdAmount
            : bidCenterDetails?.nextpossibleBidAmount;

    const [lowerSlabAmount, setLowerSlabAmount] = useState("");
    const [upperSlabAmount, setUpperSlabAmount] = useState("");
    const [slabUpdated, setSlabUpdated] = useState(false);


    // "autoBidLimitForActiveBidRefinement": 120000,
    // "isActiveBidRefinementEnabled": "Y",
    // "upperThresholdAmount": 144000,
    // "lowerThresholdAmount": 120000,
    // "lowerThresholdIncrementMultiplier": 1000,
    // "upperThresholdIncrementMultiplier": 500,

    const handleToggle = () => {
        setAutoBidEnabled(!isAutoBidEnabled);

        trackButtonClick({
            eventName: "global_alerts_enable_autobid",
            eventCategory: "Global Alerts",
            eventSource: `On ${isAutoBidEnabled ? "disable" : "enable"} auto bid`,
            eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | PageName: ${getEventCategory()}`,
            eventParams: { enabled: isAutoBidEnabled ? "false" : "true" }
        })
    };

    // Reset success state when the alert item type changes after refresh
    // This handles the case where FlatList reuses the component (same key/propertyId)
    // but the underlying alert data has changed to a different type
    useEffect(() => {
        if (showSuccess && successType && item?.type !== successType) {
            setShowSuccess(false);
            setSuccessType(null);
            setPlaceBidTapped(false);
        }
    }, [item?.type]);


    useEffect(() => {

        if (!cmsErrorMessages) {
            getCMS('global/errorMessages').then(response => {
                setCmsErrorMessages(response?.results[0]);

            });


        }
        if (activeConfigData?.length === 0) {
            getCMS(encodeURI("global/appUpdateConfig/activeBidConfig")).then(
                (response) => {
                    setActiveConfigData(response?.results);
                }
            );
        }
    }, []);

    const handlePlaceBid = async () => {
        setIsProcessing(true);
        setIsVerificationGoingForOwnitNow(true);
        try {

            const res = await isPhoneNoVerified(profileInfo?.primaryPhone);

            const isPhoneVerified = res?.data?.data;
            const phoneNo = profileInfo?.primaryPhone;

            console.log(' phoneNo', phoneNo)


            const data = { phoneNumber: phoneNo, verificationType: "sms" };

            if (!isPhoneVerified) {
                setIsProcessing(false);
                dispatch(
                    showOtpModal({
                        phoneNumber: profileInfo?.primaryPhone,
                        redirectScreen: "PDP",
                    })
                );
                dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
                const response = await sendVerificationCode(data);

                if (
                    response?.status === "FAILURE" &&
                    response?.errorCode.startsWith("Invalid")
                ) {
                }
            } else {


                getBidDetails();
            }


        } catch (error) {
            console.error("Error during bid verification:", error);
        } finally {
            setIsVerificationGoingForOwnitNow(false);
        }
    };


    const getFormatPrice = amount => {
        if (amount?.length === 0 || isNaN(amount)) {
            return "";
        }
        return amount?.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
    };

    const getFormattedPrice = amount => {
        return getFormatPrice(amount);
    };


    useEffect(() => {

        if ((userID !== null | userID !== undefined || userID?.length > 0) && globalData) {

            const host = window.location.host;

           let env = ""
           if(host === "preview.hubzu.com") {
            env =  "UAT";
           } else if(host === "hubzu.com" || host === "www.hubzu.com" || host === "mirror.hubzu.com" ||  host === "www.mirror.hubzu.com"){
            env =  "PROD";
           } else{
            env =  "INTEG";
           }

            inititaliseFirebase(globalData["firebaseConfig"][env]);

            const db = getDatabase();
            const listingDetailsRef = ref(db, "/" + globalData["firebaseConfig"][env]?.dbPath + '/listings/' + item?.listingId);



            onValue(listingDetailsRef, (snapshot) => {

                const data = snapshot.val();


                setAuctionDetails(data?.auctionDetails);
                deattachListeners(listingDetailsRef);
            });

        }

    }, [userID]);



    // const validateBidMinMaxPrice = () => {
    //     let errorMessage = ""
    //     if (amount === 0 || amount === '' || amount === '$') {
    //         errorMessage = 'Enter bid amount ';
    //     } else if (Number(amount) < bidMinLimit) {
    //         errorMessage = 'Oops! minimum bid is ' + getFormatPrice(bidMinLimit);
    //     } else if (Number(amount) > maximumPossibleBidAmount) {
    //         errorMessage = 'Oops! maximum bid is ' + getFormatPrice(maximumPossibleBidAmount);
    //     } else {
    //         errorMessage = null;
    //     }
    //     setvalidationError(errorMessage);
    // };

    let errorMessage = null;

    const validateBidMinMaxPrice = () => {
        const CHB = nextpossibleBidAmount - biddingIncrementalAmount;
        if ((parseInt(amount) - parseInt(CHB)) % biddingIncrementalAmount != 0) {
            errorMessage =
                "Please use $" +
                currencyFormatNew(biddingIncrementalAmount) +
                " increments";
            setvalidationError(
                "Please use $" +
                currencyFormatNew(biddingIncrementalAmount) +
                " increments"
            );
        } else if (amount === 0 || amount === "" || amount === "$") {
            setvalidationError(cmsErrorMessages?.EMPTY_BID_AMOUNT);
            errorMessage = cmsErrorMessages?.EMPTY_BID_AMOUNT;
        } else if (Number(amount) < bidMinLimit) {
            setvalidationError(
                cmsErrorMessages?.MIN_BID_AMOUNT.replace(
                    "###MIN_BID_AMOUNT###",
                    getFormatPrice(bidMinLimit)
                )
            );
            errorMessage = cmsErrorMessages?.MIN_BID_AMOUNT.replace(
                "###MIN_BID_AMOUNT###",
                getFormatPrice(bidMinLimit)
            );
        } else if (
            Number(amount) > bidMaxLimit &&
            bidCenterDetails?.activeBidRefinementEnabled !== true
        ) {
            // setvalidationError(cmsErrorMessages?.MAX_BID_REACHED);
            // errorMessage = cmsErrorMessages?.MAX_BID_REACHED;

            setvalidationError(
                cmsErrorMessages?.MAX_BID_AMOUNT.replace(
                    "###MAX_BID_AMOUNT###",
                    getFormatPrice(bidMaxLimit)
                )
            );
            errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
                "###MAX_BID_AMOUNT###",
                getFormatPrice(bidMaxLimit)
            );
        } else if (Number(amount) > maximumPossibleBidAmount) {
            setvalidationError(cmsErrorMessages?.MAX_BID_REACHED);
            errorMessage = cmsErrorMessages?.MAX_BID_REACHED;
        } else {
            setvalidationError("");
            errorMessage = null;
        }

        if (
            bidCenterDetails?.activeBidRefinementEnabled === true &&
            bidCenterDetails?.currentHighestBid >= lowerThresholdAmount &&
            bidCenterDetails?.nextpossibleBidAmount < upperThresholdAmount &&
            amount > bidMinLimit + lowerThresholdIncrementMultiplier
        ) {
            setvalidationError(
                cmsErrorMessages?.MAX_BID_AMOUNT.replace(
                    "###MAX_BID_AMOUNT###",
                    getFormatPrice(bidMinLimit + lowerThresholdIncrementMultiplier)
                )
            );
            errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
                "###MAX_BID_AMOUNT###",
                getFormatPrice(bidMinLimit + lowerThresholdIncrementMultiplier)
            );
            // console.log('lowerThresholdIncrementMultiplier ----' + bidMinLimit + 2*lowerThresholdIncrementMultiplier);
        } else if (
            bidCenterDetails?.activeBidRefinementEnabled === true &&
            bidCenterDetails?.currentHighestBid >= upperThresholdAmount &&
            amount > bidMinLimit + upperThresholdIncrementMultiplier
        ) {
            setvalidationError(
                cmsErrorMessages?.MAX_BID_AMOUNT.replace(
                    "###MAX_BID_AMOUNT###",
                    getFormatPrice(bidMinLimit)
                )
            );
            errorMessage = cmsErrorMessages?.MAX_BID_AMOUNT.replace(
                "###MAX_BID_AMOUNT###",
                getFormatPrice(bidMinLimit)
            );
        } else if (
            bidCenterDetails?.activeBidRefinementEnabled === true &&
            parseInt(amount) >=
            parseInt(
                lowerThresholdAmount +
                (nextpossibleBidAmount % biddingIncrementalAmount) +
                biddingIncrementalAmount
            ) &&
            nextpossibleBidAmount <=
            lowerThresholdAmount +
            (nextpossibleBidAmount % biddingIncrementalAmount)
        ) {
            /* bid amount in the border of lower threshhold  added equal to for HUBZ-3027*/
            setvalidationError(
                "The maximum possible bid amount is  $" +
                currencyFormatNew(
                    parseInt(lowerSlab) +
                    (nextpossibleBidAmount % biddingIncrementalAmount)
                )
            );
            errorMessage =
                "The maximum possible bid amount is  $" +
                currencyFormatNew(
                    parseInt(lowerSlab) +
                    (nextpossibleBidAmount % biddingIncrementalAmount)
                );

            //console.log("New3");
        } else if (
            bidCenterDetails?.activeBidRefinementEnabled === true &&
            parseInt(amount) >
            parseInt(
                upperThresholdAmount +
                (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
            ) &&
            nextpossibleBidAmount <
            upperThresholdAmount +
            (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
        ) {
            /* bid amount in the border of upper threshhold */
            setvalidationError(
                "The maximum possible bid amount is  $" +
                currencyFormatNew(
                    parseInt(upperSlab) +
                    (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
                )
            );

            errorMessage =
                "The maximum possible bid amount is  $" +
                currencyFormatNew(
                    parseInt(upperSlab) +
                    (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
                );
        } else if (
            bidCenterDetails?.activeBidRefinementEnabled === true &&
            parseInt(amount) >
            parseInt(upperSlab - upperThresholdIncrementMultiplier) +
            parseInt(upperThresholdIncrementMultiplier) *
            activeConfigData?.upperThreshHoldMaxCount
        ) {
            setvalidationError(
                "The maximum possible bid amount is $" +
                currencyFormatNew(
                    parseInt(upperSlab - upperThresholdIncrementMultiplier) +
                    parseInt(upperThresholdIncrementMultiplier) *
                    activeConfigData?.upperThreshHoldMaxCount
                )
            );

            errorMessage =
                "The maximum possible bid amount is  $" +
                currencyFormatNew(
                    parseInt(upperSlab) +
                    (nextpossibleBidAmount % lowerThresholdIncrementMultiplier)
                );

            // setBidAmountError(true);

            console.log("errorMessage ", errorMessage);
        }

        if (
            previousBidDetails &&
            previousBidDetails?.isAutoBidSelected &&
            amount <=
            previousBidDetails?.autoBidAmountDetail?.bidAmount
        ) {
            const totalAmnt =
                previousBidDetails?.autoBidAmountDetail?.bidAmount +
                biddingIncrementalAmount;

            errorMessage =
                "$" +
                currencyFormatNew(amount) +
                " is not a possible bid amount. You can bid for $" +
                currencyFormatNew(totalAmnt) +
                " instead";

            setvalidationError(
                "$" +
                currencyFormatNew(amount) +
                " is not a possible bid amount. You can bid for $" +
                currencyFormatNew(totalAmnt) +
                " instead"
            );
        }
        return errorMessage;
    };

    const handleDecrement = () => {


        setvalidationError("");

        trackEvent({
            name: "place_bid_calculate_bid_reduction",
            category: "Global Alerts",
            eventSource: "on bid amount decrease",
            eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | PageName: ${getEventCategory()}`,
            eventParams: { source: "global_alerts" }
        })

        if (amount > bidMinLimit) {
            if (
                bidCenterDetails?.activeBidRefinementEnabled === true &&
                bidCenterDetails?.currentHighestBid >= lowerThresholdAmount &&
                bidCenterDetails?.currentHighestBid < upperThresholdAmount
            ) {
                const newAmnt = parseFloat(cleanAmount(amount)) - lowerThresholdIncrementMultiplier
                setAmount(newAmnt);
                setBidIncrementCount(bidIncrementCount - 1);

                getBidAmountDetail(
                    item.listingId,
                    newAmnt
                ).then((res) => {
                    setBuyerAmountInfo(res?.data?.data);
                });
            } else if (
                bidCenterDetails?.activeBidRefinementEnabled === true &&
                bidCenterDetails?.currentHighestBid >= upperThresholdAmount
            ) {
                const newAmnt = parseFloat(cleanAmount(amount)) - upperThresholdIncrementMultiplier
                setAmount(amount - upperThresholdIncrementMultiplier);
                getBidAmountDetail(
                    item.listingId,
                    newAmnt
                ).then((res) => {
                    setBuyerAmountInfo(res?.data?.data);
                });
                setBidIncrementCount(bidIncrementCount - 1);
            } else {
                const newAmnt = parseFloat(cleanAmount(amount)) - biddingIncrementalAmount

                setAmount(newAmnt);
                getBidAmountDetail(
                    item.listingId,
                    newAmnt
                ).then((res) => {
                    setBuyerAmountInfo(res?.data?.data);
                });
            }
        }

        validateBidMinMaxPrice();

    };


    useEffect(() => {
        if (selectedMessageId && messageId) {
            hanldPhoneVerifications()
            // getBidDetails();
        }
    }, [selectedMessageId, messageId]);

    useEffect(() => {
        if (item) {
            trackPageMount({
            pageName: "listing_got_update",
            eventCategory: "DEBUG:GlobalAlerts",
            eventSource: "on alert items load",
            eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | highestBidAmount: ${item?.bidCenterAlertDetails?.currentHighestBid} | initState: false`,
            });
        }
    }, []);

    const hanldPhoneVerifications = async () => {
        const res = await isPhoneNoVerified(profileInfo?.primaryPhone);

        const isPhoneVerified = res?.data?.data;
        const phoneNo = profileInfo?.primaryPhone;

        console.log(' phoneNo', phoneNo)


        const data = { phoneNumber: phoneNo, verificationType: "sms" };

        if (!isPhoneVerified) {
            setIsProcessing(false);
            dispatch(
                showOtpModal({
                    phoneNumber: profileInfo?.primaryPhone,
                    redirectScreen: "PDP",
                })
            );
            dispatch(setIsOtpVerificationModalRequired(!isPhoneVerified));
            const response = await sendVerificationCode(data);

            if (
                response?.status === "FAILURE" &&
                response?.errorCode.startsWith("Invalid")
            ) {
            }
        } else {
            if (selectedMessageId && messageId) {
                setPlaceBidTapped(selectedMessageId.trim() === messageId.trim());
                handlePlaceBid()
                getBidDetails();
            }
        }
    }


    // const validateAutobidAmount = (autobidAmnt) => {


    //     const amnt = autobidAmnt ? autobidAmnt : autoBidAmount

    //     if (cleanAmount(amnt) > bidCenterDetails?.maximumPossibleBidAmount) {
    //         const error = `Oops! Max bid amount is $ ${getFormatPrice(bidCenterDetails?.maximumPossibleBidAmount)}`

    //         setAutoBidValidationError(error)

    //     }
    //     else if (buyerAmountInfo?.isActiveBidRefinementEnabled === "Y" && cleanAmount(amnt) > parseFloat(buyerAmountInfo.autoBidLimitForActiveBidRefinement)) {
    //         const error = `The maximum possible autobid limit is ${getFormatPrice(buyerAmountInfo.autoBidLimitForActiveBidRefinement)}`
    //         setAutoBidValidationError(error)
    //     }

    //     else if (cleanAmount(amnt) < parseFloat(amount)) {
    //         setAutoBidValidationError("Limit must exceed original bid amount")
    //     }

    //     else {
    //         setAutoBidValidationError("")
    //     }


    // }

    const validateAutobidAmount = (autobidAmnt) => {
        let error = "";
        const amnt = autobidAmnt ? autobidAmnt : autobidAmountInfo?.bidAmount;
        const minBidAmnt =
            parseInt(cleanAmount(amount)) +
            parseInt(bidCenterDetails?.biddingIncrementalAmount);

        const CHB =
            nextpossibleBidAmount -
            bidCenterDetails?.biddingIncrementalAmount;


        if (cleanAmount(amnt) === undefined || cleanAmount(amnt) === 0) {
            error = `Limit must exceed orignal bid amount`;

            setAutoBidValidationError(`Limit must exceed orignal bid amount `);
        } else if (
            (parseInt(amnt) - parseInt(CHB)) %
            bidCenterDetails?.biddingIncrementalAmount !=
            0
        ) {

            error =
                "Please use $" +
                currencyFormatNew(bidCenterDetails?.biddingIncrementalAmount) +
                " increments";
            setAutoBidValidationError(error);
        } else if (
            cleanAmount(amnt) > bidCenterDetails?.maximumPossibleBidAmount &&
            buyerAmountInfo?.isActiveBidRefinementEnabled !==
            "Y"
        ) {
            error = `Oops! Max bid amount is $ ${getFormatPrice(
                bidCenterDetails?.maximumPossibleBidAmount
            )}`;

            setAutoBidValidationError(error);
        } else if (
            buyerAmountInfo?.isActiveBidRefinementEnabled ===
            "Y" &&
            parseInt(cleanAmount(amnt)) >=
            parseInt(
                lowerThresholdAmount +
                (nextpossibleBidAmount % biddingIncrementalAmount) +
                biddingIncrementalAmount
            ) &&
            nextpossibleBidAmount <=
            lowerThresholdAmount +
            (nextpossibleBidAmount % biddingIncrementalAmount)

            // cleanAmount(amnt) >
            // parseFloat(
            //   bidPageDetail?.currentBidAmountDetail
            //     ?.autoBidLimitForActiveBidRefinement
            // )
        ) {
            error = ` The maximum possible autobid limit is ${getFormatPrice(
                lowerThresholdAmount +
                (nextpossibleBidAmount % biddingIncrementalAmount)
            )}`;
            setAutoBidValidationError(error);
        } else if (cleanAmount(amnt) < parseFloat(minBidAmnt)) {
            error = `Limit must exceed orignal bid amount`;

            setAutoBidValidationError(`Limit must exceed orignal bid amount `);
        } else {
            if (
                (parseInt(amnt) - parseInt(CHB)) %
                bidCenterDetails?.biddingIncrementalAmount !=
                0
            ) {
                error =
                    "Please use $" +
                    currencyFormatNew(bidCenterDetails?.biddingIncrementalAmount) +
                    " increments";
                setAutoBidValidationError(error);
            } else {
                error = "";
                setAutoBidValidationError("");
            }
        }
        return error;
    };
    const handleIncrement = () => {

        setvalidationError('');

        trackEvent({
            name: "place_bid_calc_increment",
            category: "Global Alerts",
            eventSource: "on bid amount increase",
            eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | PageName: ${getEventCategory()}`,
            eventParams: { source: "global_alerts" }
        })

        if (amount < bidMaxLimit) {
            if (
                bidCenterDetails?.activeBidRefinementEnabled === true &&
                bidCenterDetails?.nextpossibleBidAmount >= lowerThresholdAmount &&
                bidCenterDetails?.nextpossibleBidAmount < upperThresholdAmount
            ) {

                if (amount < (bidMinLimit + (2 * lowerThresholdIncrementMultiplier))) {

                    const newAmnt = parseFloat(cleanAmount(amount)) + lowerThresholdIncrementMultiplier;
                    getBidAmountDetail(
                        item.listingId,
                        cleanAmount(newAmnt)
                    ).then((res) => {
                        setBuyerAmountInfo(res?.data?.data);
                    });
                    setAmount(newAmnt);
                    setBidIncrementCount(bidIncrementCount + 1);
                } else {
                    validateBidMinMaxPrice();
                }
            } else if (
                bidCenterDetails?.activeBidRefinementEnabled === true &&
                bidCenterDetails?.nextpossibleBidAmount >= upperThresholdAmount
            ) {
                if (
                    bidIncrementCount < 0 &&
                    bidCenterDetails?.nextpossibleBidAmount > upperThresholdAmount
                ) {
                    const newAmnt = parseFloat(cleanAmount(amount)) + upperThresholdIncrementMultiplier;
                    getBidAmountDetail(
                        item.listingId,
                        cleanAmount(newAmnt)
                    ).then((res) => {
                        setBuyerAmountInfo(res?.data?.data);
                    });
                    setAmount(newAmnt);
                    //   setAmount(amount + upperThresholdIncrementMultiplier);

                    setBidIncrementCount(bidIncrementCount + 1);
                } else {
                    validateBidMinMaxPrice();
                }
            } else {

                const newAmnt = parseFloat(cleanAmount(amount)) + biddingIncrementalAmount;
                getBidAmountDetail(
                    item.listingId,
                    cleanAmount(newAmnt)
                ).then((res) => {
                    setBuyerAmountInfo(res?.data?.data);
                });
                setAmount(newAmnt);

                // setAmount(amount + biddingIncrementalAmount);
            }
        }
        validateBidMinMaxPrice();

    };


    // const handleIncrement = () => {

    //     setvalidationError("");

    //     if (amount < bidMaxLimit && amount >= bidMinLimit) {
    //         if (
    //             bidCenterDetails?.activeBidRefinementEnabled === true &&
    //             bidCenterDetails?.nextpossibleBidAmount >= lowerThresholdAmount &&
    //             bidCenterDetails?.nextpossibleBidAmount < upperThresholdAmount
    //         ) {
    //             if (amount < (bidMinLimit + lowerThresholdIncrementMultiplier)) {

    //                 console.log('lowerThresholdIncrementMultiplier ->', lowerThresholdIncrementMultiplier);
    //                 const newAmnt = parseFloat(cleanAmount(amount)) + lowerThresholdIncrementMultiplier;

    //                 setAmount(newAmnt);
    //                 setBidIncrementCount(bidIncrementCount + 1);
    //                 getBidAmountDetail(
    //                     item.listingId,
    //                     cleanAmount(newAmnt)
    //                 ).then((res) => {
    //                     setBuyerAmountInfo(res?.data?.data);
    //                 });

    //             } else {
    //                 validateBidMinMaxPrice();
    //             }
    //         } else if (
    //             bidCenterDetails?.activeBidRefinementEnabled === true &&
    //             bidCenterDetails?.nextpossibleBidAmount >= upperThresholdAmount
    //         ) {
    //             if (
    //                 bidIncrementCount < 0 &&
    //                 bidCenterDetails?.nextpossibleBidAmount > upperThresholdAmount
    //             ) {
    //                 const newAmnt = parseFloat(cleanAmount(amount)) + upperThresholdIncrementMultiplier;

    //                 setAmount(newAmnt);
    //                 setBidIncrementCount(bidIncrementCount + 1);
    //                 getBidAmountDetail(
    //                     item.listingId,
    //                     newAmnt
    //                 ).then((res) => {
    //                     setBuyerAmountInfo(res?.data?.data);
    //                 });

    //             } else {
    //                 validateBidMinMaxPrice();
    //             }
    //         } else {
    //             const newAmnt = parseFloat(cleanAmount(amount)) + biddingIncrementalAmount;
    //             setAmount(newAmnt);
    //             getBidAmountDetail(
    //                 item.listingId,
    //                 newAmnt
    //             ).then((res) => {
    //                 setBuyerAmountInfo(res?.data?.data);
    //             });
    //         }
    //     } else if (amount < bidMinLimit) {
    //         setAmount(item.bidCenterAlertDetails.nextpossibleBidAmount);
    //         getBidAmountDetail(
    //             item.listingId,
    //             cleanAmount(item.bidCenterAlertDetails.nextpossibleBidAmount)
    //         ).then((res) => {
    //             setBuyerAmountInfo(res?.data?.data);
    //         });

    //     }
    //     else {
    //         validateBidMinMaxPrice();
    //     }
    // };

    const getBackUpBidAmount = async (e) => {

        const amnt = e?.target?.value ? e?.target?.value : 0;
        setAmount(cleanAmount(amnt));
        const response = await isAvailableBackUpBidAmount({
            listingId: item?.listingId,
            bidAmount: amnt?.length > 0 ? parseInt(cleanAmount(amnt?.trim())) : 0,
        });

        if (response.data !== null) {


            setHideDisplayMessage(response.data.hideDisplayMessage);
            setMaxBackUpBidLimit(response.data.maxBackUpBidLimit);
            setFormattedMaxBackUpBidLimit(response.data.formattedMaxBackUpBidLimit);
            if (formattedMinBackUpBidLimit.length === 0) {
                setFormattedMinBackUpBidLimit(response.data.formattedMinBackUpBidLimit);
                setAmountInfoMessage(
                    "Place a bid at or above the minimum amount of " +
                    response.data.formattedMinBackUpBidLimit
                );
                setMinBackUpBidLimit(response.data.minBackUpBidLimit);
            }
            setIncrementMultplier(response.data.incrementMultplier);
            setBackupBidErrorCode(response.data.errorCode);
            //validations
            if (!firstTime) {

                if (cleanAmount(amnt?.trim()).length === 0) {
                    //   setBidAmountError(true);
                    setvalidationError("Please enter the bid amount");
                } else if (
                    response.data.errorCode === "BACKUP_BID_MUST_BE_MULTIPLE_OF_INCREMENT"
                ) {
                    //   setBidAmountError(true);
                    setvalidationError(
                        "Your bid must be in multiples of $" +
                        currencyFormatNew(response.data.incrementMultplier)
                    );
                } else if (response.data.errorCode === "MAX_BACKUP_LIMIT_REACHED") {
                    //   setBidAmountError(true);
                    setvalidationError(
                        "You've already placed a bid at the maximum amount allowed."
                    );
                } else if (
                    response.data.errorCode === "BACKUP_BID_MUST_BE_GREATER_THAN_MIN"
                ) {
                    //   setBidAmountError(true);
                    setvalidationError(
                        "Your bid needs to be at least " + formattedMinBackUpBidLimit
                    );
                } else if (
                    response.data.errorCode === "BACKUP_BID_MUST_BE_LESSER_THAN_MAX"
                ) {
                    //   setBidAmountError(true);
                    setvalidationError(
                        "Your bid needs to be equal to or less than the maximum bid of " +
                        formattedMaxBackUpBidLimit
                    );
                } else if (
                    response.data.errorCode === "HIGHER_BACKUP_BID_AVAILABLE_FOR_USER"
                ) {
                    //   setBidAmountError(true);
                    setvalidationError(
                        "Your backup bid can't be lower than your current bid."
                    );
                } else if (response.data.errorCode === 'BACKUP_NOT_AVAILABLE') {
                    setvalidationError(
                        "Another user has already placed a bid for that amount, you can bid starting at " +

                        formattedMinBackUpBidLimit

                    );
                }

                else {
                    //   setBidAmountError(false);
                    setvalidationError("");
                    getBidAmountDetail(
                        item.listingId,
                        cleanAmount(amnt)
                    ).then((res) => {
                        setBuyerAmountInfo(res?.data?.data);
                    });
                    //   refreshDetails(amnt);
                    // isError = false;
                }
                // if (bidAmountError) {
                //     const params = {
                //         error: bidAmountErrorText,
                //         ErrorField: "Bid Amount",
                //     };
                // }
            }
        }
        setFirtTime(false);
    };

    const cleanAmount = (amountString) => {
        const str = amountString?.toString();
        return str?.replace(/[$,]/g, '');
    };

    const getAmountDetailsData = (e) => {

        const amnt = (cleanAmount(e.target.value));

        // console.log('amnt ->', amnt);
        setAmount(cleanAmount(e.target.value));

        trackEvent({
            name: "place_bid_amount_change",
            category: "Global Alerts",
            eventSource: "on bid amount enter / change",
            eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | Confirm Pane opened:true | PageName: ${getEventCategory()}`,
            eventParams: { source: "global_alerts", bid_amount: amnt }
        })

        getBidAmountDetail(
            item.listingId,
            cleanAmount(e.target.value)
        ).then((res) => {
            setBuyerAmountInfo(res?.data?.data);
        });

        let errorMessage = ""
        if (amnt === 0 || amnt === '' || amnt === '$') {
            errorMessage = 'Enter bid amount ';
        } else if (Number(amnt) < bidMinLimit) {
            errorMessage = 'Oops! minimum bid is ' + getFormatPrice(bidMinLimit);
        } else if (Number(amnt) > maximumPossibleBidAmount) {
            errorMessage = 'Oops! maximum bid is ' + getFormatPrice(maximumPossibleBidAmount);
        } else {
            errorMessage = null;
        }
        setvalidationError(errorMessage);
        // validateBidMinMaxPrice();
    }

    const getAutobidAmountDetailsData = (e) => {


        setAutoBidAmount(cleanAmount(e.target.value));

        getautobidAmount(
            item.listingId,
            cleanAmount(e.target.value).length === 0 ? 0 : cleanAmount(e.target.value)
        ).then((res) => {
            setAutobidAmountInfo(res?.data?.data);
        });

        validateAutobidAmount(cleanAmount(e.target.value));
    }


    const getBidDetails = async () => {
        setViewDetailsTapped(false);

        trackButtonClick({
            eventName: "global_alerts_place_bid",
            eventCategory: "Global Alerts",
            eventSource: "on place bid click",
            eventLabel: ` listingId: ${item.listingId}| PageName: ${getEventCategory()}`,
            eventParams: {
              bid_type:
                item.type === "BACKUPBID"
                  ? "backup_bid"
                  : item.type === "BACKUP_BID_EXPIRY"
                  ? "update_backup_bid_time_limit"
                  : "place_bid",
            },
        })


        const response = await getPreviousBidDetails({
            bidAmount: item.lastBidAmount,
            bidType: 'PLACE_BACKUP_BID',
            buyerEmail: item.buyerEmailId,
            listingId: item.listingId,
        });

        if (response.data.status === 'SUCCESS') {
            setIsProcessing(false);
            if (item.type === 'BACKUP_BID_EXPIRY' || item.type === 'BACKUPBID') {

                getBackUpBidAmount(item)
                setPlaceBidTapped(true);

                setPreviousBidDetails(response.data.data);


                getBidContingency(
                    item.listingId,
                    response?.data?.data?.finacingDetail?.paymentType,
                    cleanAmount(amount)
                ).then((res) => {
                    setBidContingency(res.data);


                });
                if (item.type === 'BACKUP_BID_EXPIRY') {
                    getBidAmountDetail(
                        item.listingId,
                        cleanAmount(amount)
                    ).then((res) => {
                        setBuyerAmountInfo(res?.data?.data);
                    });
                }
            }
            else {

                getBidAmountDetail(
                    item.listingId,
                    cleanAmount(amount)
                ).then((res) => {
                    setBuyerAmountInfo(res?.data?.data);
                    setPlaceBidTapped(true);

                    setPreviousBidDetails(response.data.data);
                    setAutobidAmountInfo(response?.data?.data?.autoBidAmountDetail);
                    setAutoBidAmount(response?.data?.data?.autoBidAmountDetail?.bidAmount);
                    setAutoBidEnabled(response?.data?.data?.autoBidAmountDetail !== null ? true : false);
                    getBidContingency(
                        item.listingId,
                        response?.data?.data?.finacingDetail?.paymentType,
                        cleanAmount(amount)
                    ).then((res) => {
                        setBidContingency(res.data);


                    });

                });


            }


        } else if (response?.data?.status === 'FAILURE') {
            setIsProcessing(false);
            if (response.data?.errorCode === 'BID_DEPOSIT_REQUIRED') {



                const jsonString = `{"stage":"BID_DEPOSIT","errorCode":null,"bidDepositAmount":1000.0,"buyerEmailId":null,"isFraudulentBid":"N","paymentGatewayPublicKey":"pk_test_tT8O1LMPQCQfeFxIM6AmioUa00QVnwcAtI","isBidDepositChargeApplicable":"Y","bidDepositChargeAmount":0.5,"valid":false}`;

                try {
                    const data = JSON.parse(jsonString);
                    const bidDepositAmount = data.bidDepositAmount;
                    setBidErrorMessage(`This is a one-time Bid Deposit (hold) of ₹${bidDepositAmount} to be placed on your credit card. For more information, please see our FAQ's.`);
                    const details = await getPDPInitData(item?.listingId);

                    const bidcenterdata = await getBidCenterDetails(item?.listingId);

                    dispatch(fetchPDPBidCenterDataSuccess(bidcenterdata));
                    dispatch(
                        fetchPDPLatestBidCenterData(item?.listingId)
                    );
                    dispatch(fetchPDPInitialLoadSuccess(details));
                    dispatch(setListingId(item?.listingId));
                    dispatch(setSelectedBidAmount(null));

                    navigate("/bid")

                } catch (error) {
                    console.error("Invalid JSON:", error);
                }

            }




        }

    }

    const handleBidwizarddNavigation = async (type) => {
        trackButtonClick({
            eventName: type === "cif" ? "global_alerts_cif_click" : "global_alerts_edit_bid_click",
            eventCategory: "Global Alerts",
            eventSource: `${type === "cif" ? getEventCategory() : "On Edit bid details click"}`,
            eventSourceRequired: type === "cif",
            eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | PageName: ${getEventCategory()}`
        })

        const details = await getPDPInitData(item?.listingId);

        const bidcenterdata = await getBidCenterDetails(item?.listingId);

        dispatch(fetchPDPBidCenterDataSuccess(bidcenterdata));
        dispatch(
            fetchPDPLatestBidCenterData(item?.listingId)
        );
        dispatch(fetchPDPInitialLoadSuccess(details));
        dispatch(setListingId(item?.listingId));
        dispatch(setSelectedBidAmount(null));

        navigate("/bid")


    };

    const handleNavigateToPDP = () => {
        navigateToProperty(`/property/${item?.propertyId}`, item?.bidCenterAlertDetails?.propertyCategory, item?.bidCenterAlertDetails?.propertyStatus);

        trackButtonClick({
            eventName: `global_alerts_location_click`,
            eventCategory: "Global Alerts",
            eventSource: `on location link click`,
            eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | PageName: ${getEventCategory()}`
        })
    };

    const currencyFormatNew = (num) => {
        return Number(num)
            ?.toFixed(0)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    };

    const endTheAuctionNow = async () => {

        trackButtonClick({
            eventName: `global_alerts_own_it_now`,
            eventCategory: "Global Alerts",
            eventSource: `On end auction now click`,
            eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | PageName: ${getEventCategory()}`
        })

        setEndtheAuctionNow(true);
        getBidAmountDetail(
            item.listingId,
            item.buyItNowPrice,
        ).then((res) => {
            setBuyerAmountInfo(res?.data?.data);
        });
        const response = await getPreviousBidDetails({
            bidAmount: item.buyItNowPrice,
            bidType: 'OWN_IT_NOW',
            buyerEmail: item.buyerEmailId,
            listingId: item.listingId,
        });
        if (response.data.status === 'SUCCESS') {
            setPreviousBidDetails(response.data.data);
            setAutobidAmountInfo(response?.data?.data?.autoBidAmountDetail);
            setAutoBidAmount(response?.data?.data?.autoBidAmountDetail?.bidAmount);
            setAutoBidEnabled(response?.data?.data?.autoBidAmountDetail !== null ? true : false);


            const res = await getBidContingency(
                item.listingId,
                response?.data?.data?.finacingDetail?.paymentType,
                cleanAmount(amount)
            );
            if (res) {
                setBidContingency(res);


            }
        } else if (response.status === 'FAILURE') {

        }

    }

    const getBgColor = () => {
        return (placeBidTapped || viewDetailsTapped) ? "bidBg" : "";
    }

    const handleClose = () => {
        setAmount(item?.bidCenterAlertDetails?.nextpossibleBidAmount);
        setAutoBidAmount(autobidAmountInfo?.bidAmount);
        setShouldShowError(false);
        setvalidationError("");
        setBidErrorMessage("")
        setPlaceBidTapped(false);
        setEndtheAuctionNow(false);

        trackButtonClick({
            eventName: "global_alerts_close_confirm_pane",
            eventCategory: "Global Alerts",
            eventSource: "On place bid close icon click",
            eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | highestBidAmount: ${item?.bidCenterAlertDetails?.currentHighestBid} | PageName: ${getEventCategory()}`,
        })
    }


    const getBidType = () => {
        if (endTheAuctionNowTapped) {
            return "OWN_IT_NOW"
        } else if (item?.type === 'BACKUP_BID_EXPIRY' || item.type === 'BACKUPBID') {
            return "PLACE_BACKUP_BID"
        } else {
            return "PLACE_BID"
        }
    }

    const handleAlertRefresh = () => {
      // Delay refresh to keep the success message visible for at least 5 seconds
      setTimeout(() => {
        getAlertData().then((res) => {
          dispatch(
            setAlerts({
              ...res,
              alerts: [...res.alerts], // ensures new reference
            }),
          );

          trackApiCall({
            eventName: "listing_got_update",
            eventCategory: "DEBUG:GlobalAlerts",
            eventSource: "after successful bidding listing update",
            eventLabel: `listingId: ${item.listingId} | highestBidAmount: ${item?.bidCenterAlertDetails?.currentHighestBid} | initState: true}`,
          });
        });
      }, 5000);
    };


    const confirmBid = async () => {
        trackButtonClick({
            eventName: "global_alerts_confirm_bid",
            eventCategory: getEventCategory(),
            eventSource: "On confirm bid click",
            eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | PageName: ${getEventCategory()}`,
        })



        let hasError = false
        var isAutobidValid = true;

        if (isAutoBidEnabled) {
            const isError = validateAutobidAmount();



            if ((autoBidValidationError?.length === 0 && isError?.length <= 1) || endTheAuctionNowTapped) {
                isAutobidValid = true;
            } else {
                isAutobidValid = false
            }

        }

        if (item.type === "BACKUP_BID_EXPIRY") {
            if (backupDuration.length <= 1) {
                hasError = true
            }

        }

        if (item.type === "OUTBID") {
            const error = validateBidMinMaxPrice();


            if (error?.length > 0) {
                hasError = true
            }
        }




        if (validationError?.length === 0 && isAutobidValid && !hasError) {
            const bidPayload = {
                "bidId": null,
                "listingId": item?.listingId,
                "userId": previousBidDetails?.userId,
                "bidAmountDetail": item?.type === 'BACKUP_BID_EXPIRY' ? previousBidDetails?.bidAmountDetail : buyerAmountInfo,
                "isBackupBidSelected": previousBidDetails?.isBackupBidSelected,
                "backupBidDaysSelected": item?.type === 'BACKUP_BID_EXPIRY' ? backupDuration?.toString() : previousBidDetails?.backupBidDaysSelected,
                "isAutoBidSelected": isAutoBidEnabled,
                "autoBidAmountDetail": autobidAmountInfo,
                "formattedAutoBidLimit": null,
                "isIntendToOccupy": previousBidDetails?.isBackupBidSelected,
                "holdActiveLicense": previousBidDetails?.isIntendToOccupy,
                "isAfBaAccepted": previousBidDetails?.isAfBaAccepted,
                "finacingDetail": {
                    "bidContigencies": previousBidDetails?.finacingDetail?.bidContigencies,
                    "bidContingencyMasterList": bidContingency,
                    "closingOptionDetail": previousBidDetails?.finacingDetail?.closingOptionDetail,
                    "contingentUponFlag": previousBidDetails?.finacingDetail?.contingentUponFlag,
                    "financingOption": previousBidDetails?.finacingDetail?.financingOption,
                    "isBPFinanced": previousBidDetails?.finacingDetail?.isBPFinanced,
                    "loanAmount": previousBidDetails?.finacingDetail?.loanAmount,
                    "loanPreApprovalDetail": {
                        "institutionName": previousBidDetails?.finacingDetail?.loanPreApprovalDetail?.institutionName,
                        "isPreApprovedForFinance": previousBidDetails?.finacingDetail?.loanPreApprovalDetail?.isPreApprovedForFinance,
                        "preApprovedAmount": previousBidDetails?.finacingDetail?.loanPreApprovalDetail?.preApprovedAmount,
                        "preApprovedAmountFormatted": previousBidDetails?.finacingDetail?.loanPreApprovalDetail?.preApprovedAmountFormatted,
                    },
                    "paymentType": previousBidDetails?.finacingDetail?.paymentType,
                },
                "isActiveBid": previousBidDetails?.isActiveBid,
                "buyerEmail": previousBidDetails?.bidSubmitterRole === "AGENT" ? previousBidDetails?.buyerEmail : "",
                "bidType": getBidType(),
                "propertyTouredSelected": previousBidDetails?.propertyTouredSelected,
                "premiumPaidBy": previousBidDetails?.premiumPaidBy,
                "bidSubmitterRole": previousBidDetails?.bidSubmitterRole,
                "bidPlacedBy": previousBidDetails?.bidPlacedBy,
                "isUpdateExpiryRequest": item?.type === 'BACKUP_BID_EXPIRY' ? true : previousBidDetails?.isUpdateExpiryRequest,
                "expiryRequestBackupBidId": previousBidDetails?.expiryRequestBackupBidId,
                "checkBuyerEmail": previousBidDetails?.checkBuyerEmail,
            }






            const response = await submitBid(bidPayload);
            if (response?.data?.status === "SUCCESS") {
                setEndNowAmount(buyerAmountInfo?.bidAmount)
                // Capture the current item type at the time of success so it persists after alert refresh
                setSuccessType(item?.type);
                // console.log('response?.data?.statusCodes 2-> ', response?.data?.data?.statusCodes);

                if (response?.data?.data?.statusCodes?.length > 0) {
                    // console.log('response?.data?.statusCodes -> ', response?.data?.data?.statusCodes?.length);
                    if (response?.data?.data?.statusCodes[0] === 'OUTBID' || response?.data?.data?.statusCodes[0] === 'REJECTED') {
                        setShowSuccess(false);
                        setBidErrorMessage("Oops! Someone already placed a higher bid than $" + item.bidCenterAlertDetails?.formattedCurrentHighestBid)
                    } else {

                        setBidErrorMessage("");
                        setShowSuccess(true);
                    }
                } else {
                    setShowSuccess(true);
                    setBidErrorMessage("");
                    const resultData = response?.data?.data;

                    trackEvent({
                      name: "bid_placed",
                      category: "New-Bid Wizard",
                      eventSource: "Global Alerts-RepeatBid",
                      property_type: getPropertyType(
                        bidCenterDetails?.propertyCategory,
                      ),
                      seller_id: bidCenterDetails?.sellerId,
                      bidId: resultData?.bidId,
                      listingId: resultData?.listingId,
                    });

                    trackButtonClick({
                        eventName: "global_alerts_autobid_status",
                        eventCategory: getEventCategory(),
                        eventSource: "on confirm bid success",
                        eventParams: { enabled: isAutoBidEnabled ? "enabled" : "disabled" },
                        eventLabel: `listingId: ${item.listingId} | highestBidAmount: ${item?.bidCenterAlertDetails?.currentHighestBid} | initState: true}`,
                    })
                }
                handleAlertRefresh();

            } else {
                if (response?.data?.errorCode === "INVL_BID_AMNT") {
                    setShowSuccess(false);
                    setBidErrorMessage("Please Enter valid Bid Amount!")
                } else {
                    setShowSuccess(false);
                    setBidErrorMessage("Error while placing bid, please try again later")
                }


                //alert
                // ("failed to execute the place bid");
            }
        }

    }

    // Function to format address
    const getFormattedAddress = (propertyAddress) => {
        if (!propertyAddress) return "N/A";
        const { streetNumber, streetName, city, state, zip } = propertyAddress;
        return `${streetNumber || ""} ${streetName || ""}, ${city || ""}, ${state || ""
            } ${zip || ""}`.trim();
    };

    const shouldShowAutoBid = () => {

        if (buyerAmountInfo?.isActiveBidRefinementEnabled === "Y") {
            // console.log('buyerAmountInfo ->', buyerAmountInfo)
            if (parseFloat(cleanAmount(amount)) < parseInt(buyerAmountInfo.autoBidLimitForActiveBidRefinement)) {
                return true;
            } else {

                return false
            }
        }

        if (item?.type === 'BACKUP_BID_EXPIRY' || item.type === 'BACKUPBID') {
            return false;
        }
        return true;

    }

    const renderCIFReminder = () => {
        return (
            <>

                <div className='cif-header-error'> <MdErrorOutline size={20} color="red" />{" "} Complete you contact information</div>

                <p className='ga-cif-description'>{" "}Complete you contact information
                    Congrats, your bid for the property

                    <a id="alert-cif-property-link" onClick={handleNavigateToPDP} className='cif-property-description'>{" " + getFormattedAddress(item?.propertyAddress) + " "}</a>

                    has been submitted successfully! Please provide now your contact information to process the closing sooner in the event your bid is selected by the seller.</p>

                <Row>
                    <Col xs={6} md={6}>
                        <button
                            id="alert-complete-cif-btn"
                            onClick={handleBidwizarddNavigation}
                            type="submit"
                            className="btn btn-primary ga-cif-cta">
                            Complete CIF
                        </button></Col>
                    <Col xs={6} md={6}>
                        <CountdownTimer
                            until={
                                item?.cifDetails.timeLeft

                            }
                        /></Col>

                </Row>



            </>
        )


    }

    const renderBackupBidAlert = (item) => {

        return (

            item?.type === 'BACKUPBID' ?
                <><Row xs={12} md={8}>
                    <p className="headerText d-flex align-items-start pl0">
                        {item?.message}
                    </p>
                </Row><Row xs={12} md={8} className=" d-flex align-items-start p0">

                        {item.type === 'BACKUP_BID_EXPIRY' ? (
                            <p className="recentBidTxt d-flex align-items-start p0" style={{ width: "90%" }}>
                                {"  Extend your backup bid to continue participating in this auction."}
                            </p>
                        ) :
                            <p className="recentBidTxt d-flex align-items-start p0" style={{ width: "90%" }}>
                                {"Your most recent bid was $" + item.formattedLastBidAmount}
                            </p>}

                        <button
                            type="button"
                            onClick={() => handleClose()}

                            className="btn-close text-reset"
                            aria-label="Close"
                        ></button>
                    </Row><Row className="mb-4">
                        <Col md={4} style={{ paddingLeft: 0 }}>
                            <Card style={{ height: 100 }}
                                className="pointer"
                                onClick={() => navigateToProperty(`/property/${item?.propertyId}`, item?.bidCenterAlertDetails?.propertyCategory, item?.bidCenterAlertDetails?.propertyStatus)}>

                                <div className="outbid-image">
                                    <img className="img-fluid "
                                        style={{ height: '100%', width: '100%' }}
                                        src={imageOnTheWay}
                                        alt="imgOnTheWay" />

                                    {item?.favouritedProperty &&

                                        <div className="fav-icons-outbid">
                                            <FaHeart
                                                color={item?.favouritedProperty ? "#ff5a5f" : "#888D91"}
                                                className="cursor-pointer"
                                                size={18} />
                                        </div>}

                                </div>


                            </Card>
                        </Col>
                        <Col xs={12} md={8}>
                            <Row xs={12} md={12} className="d-flex align-items-start">
                                {/* <Col  md={12} > */}
                                <Col xs={12} md={5} className="d-flex align-items-start">

                                    <div className="">
                                        <p className="smallFont">{endTheAuctionNowTapped ? "End the auction now" : "Bid Amount"}  </p>
                                    </div>
                                </Col>
                                <Col xs={12} md={7} className="d-flex align-items-start">

                                    <div
                                        className="col-md-3"
                                        style={{
                                            width: "80px",
                                        }}
                                    >
                                        <div
                                            className="d-flex align-items-center justify-content-around "
                                            style={{
                                                // border: "2px solid green",
                                            }}
                                        >
                                            <input style={{ width: 70 }}
                                                id="alert-backup-bid-amount-input"
                                                value={
                                                    amount === "0" ? " " : "$" + getFormattedPrice(amount)
                                                }
                                                onChange={getBackUpBidAmount}
                                                maxLength={21}
                                                aria-label="price"
                                                type=""
                                                className="bidAmountInput"
                                            />

                                        </div>

                                    </div>


                                </Col>
                                <div>
                                    {!hideDisplayMessage && (
                                        <p style={{ fontSize: 10, fontFamily: "graphikmedium" }}>
                                            {amountInfoMessage}
                                        </p>
                                    )}
                                </div>
                                {/* </Col> */}


                            </Row>
                            {
                                buyerAmountInfo?.buyerPremiumPercentage !== null && parseInt(buyerAmountInfo?.buyerPremiumPercentage) !== 0 &&
                                <Row xs={12} md={12} className="d-flex align-items-start">
                                    <Divider style={{ fontSize: 10, width: "90%" }}></Divider>
                                    {/* <Col  md={12} > */}
                                    <Col xs={12} md={6} className="d-flex align-items-start">
                                        {bidCenterDetails?.propertyCategory === 'COMMERCIAL' ?
                                            <div className="">
                                                <p className="smallFont">Transaction Fee {(buyerAmountInfo?.buyerPremiumPercentage !== null && buyerAmountInfo?.buyerPremiumPercentage?.length !== 0 && buyerAmountInfo?.buyerPremiumPercentage !== undefined) ? "(" + buyerAmountInfo?.buyerPremiumPercentage + "%)" : ""}</p>
                                            </div>
                                            :
                                            <div className="">
                                                <p className="smallFont">Buyer's Premium {(buyerAmountInfo?.buyerPremiumPercentage !== null && buyerAmountInfo?.buyerPremiumPercentage?.length !== 0 && buyerAmountInfo?.buyerPremiumPercentage !== undefined) ? "(" + buyerAmountInfo?.buyerPremiumPercentage + "%)" : ""}</p>
                                            </div>}

                                    </Col>
                                    <Col xs={12} md={6} className="smallFont d-flex align-items-start">
                                        {buyerAmountInfo?.buyerPremiumFormatted ? buyerAmountInfo?.buyerPremiumFormatted : ''}

                                    </Col>
                                    {/* </Col> */}


                                </Row>
                            }


                            <Row xs={12} md={12} className="d-flex align-items-start">
                                <Divider style={{ fontSize: 20, width: "90%" }}></Divider>
                                {/* <Col  md={12} > */}
                                <Col xs={12} md={6} className="d-flex align-items-start">

                                    <div className="">
                                        <p className="smallFont">Total Due</p>
                                    </div>
                                </Col>
                                <Col xs={12} md={6} className="smallFont d-flex align-items-start">
                                    {buyerAmountInfo?.totalDueFormatted ? buyerAmountInfo?.totalDueFormatted : ''}
                                </Col>
                                {/* </Col> */}


                            </Row>



                        </Col>
                        {validationError?.length > 0 &&
                            (
                                <Row>
                                    <p className='errorTxt'>{validationError}</p>
                                </Row>
                            )}

                    </Row></>

                :
                <><Row xs={12} md={8}>
                    <p className="headerText d-flex align-items-start pl0">
                        {item?.message}
                    </p>
                </Row><Row xs={12} md={8} className=" d-flex align-items-start p0">

                        <p className="recentBidTxt d-flex align-items-start p0" style={{ width: "90%" }}>
                            {"  Extend your backup bid to continue participating in this auction."}
                        </p>

                        <button
                            type="button"
                            onClick={() => handleClose()}

                            className="btn-close text-reset"
                            aria-label="Close"
                        ></button>
                    </Row><Row className="mb-4">
                        <Col md={4} style={{ paddingLeft: 0 }}>
                            <Card style={{ height: 100 }}
                                className="pointer"
                                onClick={() => navigateToProperty(`/property/${item?.propertyId}`, item?.bidCenterAlertDetails?.propertyCategory, item?.bidCenterAlertDetails?.propertyStatus)}>

                                <div className="outbid-image">
                                    <img className="img-fluid "
                                        style={{ height: '100%', width: '100%' }}
                                        src={imageOnTheWay}
                                        alt="imgOnTheWay" />

                                    {item?.favouritedProperty &&

                                        <div className="fav-icons-outbid">
                                            <FaHeart
                                                color={item?.favouritedProperty ? "#ff5a5f" : "#888D91"}
                                                className="cursor-pointer"
                                                size={18} />
                                        </div>}

                                </div>


                            </Card>
                        </Col>
                        <Col xs={12} md={8}>
                            <Row xs={12} md={12} className="d-flex align-items-start">
                                {/* <Col  md={12} > */}
                                <Col xs={12} md={10} className="d-flex align-items-start">

                                    <Form.Select
                                    id="alert-backup-bid-duration-select"
                                        className="gaBackupBidDuration w-90 me-2"
                                        value={backupDuration}
                                        onChange={(e) =>
                                            setBackupDuration(Number(e.target.value))
                                        }

                                    >
                                        <option value="">Select duration</option>
                                        {item?.backUpBidExpiryDaysList?.map(
                                            (duration, i) => (
                                                <option key={i} value={duration}>
                                                    {duration} days
                                                </option>
                                            )
                                        )}
                                    </Form.Select>


                                </Col>




                            </Row>
                            {backupDuration.length <= 1 && shouldShowError &&
                                (
                                    <Row>
                                        <p className='errorTxt'>
                                            Please select an option
                                        </p>
                                    </Row>
                                )}




                        </Col>

                    </Row></>




        )

    };

    const renderSaveSearchAlert = () => {
        return (
            <div id="alert-save-search-card" style={{ cursor: 'pointer' }} onClick={(e) => { markInternalNavigation(); window.open('/' + item?.saveSearchResponse?.baseSearchUrl + "?sort=TimeLeftHL"); }}>


                <div className='save-search-header'>New Property Added!</div>

                <p className='ga-saved-search-description'>{item?.newPropertyCount + " new Properties were added to your save search " + item?.saveSearchResponse?.searchBy + " on " + item?.lastNotifiedOn}
                </p>




            </div>
        )
    }


    return (


        <div className={`${getBgColor()} p10  `}>
            <div className="">

                <Container className="mt-12 p0" >

                    {
                        item?.type === 'CIF_REMINDER' ?

                            renderCIFReminder()
                            :
                            <>

                                {
                                    bidErrorMessage?.length > 0 &&
                                    (
                                        <Row className='errorContainer'>
                                            <p className='bidErrorText'> {bidErrorMessage} </p>
                                        </Row>
                                    )

                                }
                                {/* {item?.buyerEmailId !== userEmail && */}
                                {!showSuccess &&
                                <Row xs={12} md={8} >
                                    <p className="d-flex align-items-start p0 ga-buyer-email">
                                        {item?.buyerEmailId}
                                    </p>
                                </Row>
                               }
                                {/* } */}
                                {showSuccess ?
                                    <>
                                        <Row xs={12} md={8} >
                                            <p className="congratulationsTxt p0">
                                                Congratulations!
                                            </p>
                                            {successType === "BACKUP_BID_EXPIRY" ?
                                                <p className="detailText d-flex align-items-start p0">
                                                    Backup bid expiry date updated successfully!

                                                </p>

                                                :

                                                endTheAuctionNowTapped ?

                                                    <p className="detailText d-flex align-items-start p0">
                                                        Your bid of ${endNowAmount} was successfully placed and you are now the highest bidder!
                                                    </p>
                                                    :
                                                    <p className="detailText d-flex align-items-start p0">
                                                        Your bid of ${getFormatPrice(amount)} was successfully placed and you are now the highest bidder!
                                                    </p>




                                            }


                                        </Row>
                                    </>
                                    :


                                    (placeBidTapped || endTheAuctionNowTapped) ?
                                        <div >

                                            {
                                                (item?.type === 'BACKUP_BID_EXPIRY' || item.type === 'BACKUPBID') ?

                                                    renderBackupBidAlert(item)
                                                    :


                                                    <><Row xs={12} md={8}>
                                                        <p className="headerText d-flex align-items-start pl0">
                                                            {item?.message}
                                                        </p>
                                                    </Row><Row xs={12} md={8} className=" d-flex align-items-start p0">
                                                            {item.type === 'BACKUP_BID_EXPIRY' ? (
                                                                <p className="recentBidTxt d-flex align-items-start p0" style={{ width: "90%" }}>
                                                                    {"  Extend your backup bid to continue participating in this auction."}
                                                                </p>
                                                            ) :
                                                                item?.type === 'DRIVEN_BID_WATCHER_ALERT' ?
                                                                    <p className="recentBidTxt d-flex align-items-start p0" style={{ width: "90%" }}>
                                                                        {"An opening bid was just placed for the below property. Don't let it get away."}
                                                                    </p>
                                                                    :
                                                                    <p className="recentBidTxt d-flex align-items-start p0" style={{ width: "90%" }}>
                                                                        {"Your most recent bid was $" + item.formattedLastBidAmount}
                                                                    </p>

                                                            }
                                                            <button
                                                                id="alert-close-confirmation-btn"
                                                                type="button"
                                                                onClick={() => handleClose()}

                                                                className="btn-close text-reset"
                                                                aria-label="Close"
                                                            ></button>
                                                        </Row><Row className="mb-4">
                                                            <Col md={4} style={{ paddingLeft: 0 }}>
                                                                <Card style={{ height: 100 }}
                                                                id="alert-property-card"
                                                                    className="pointer"
                                                                    onClick={() => navigateToProperty(`/property/${item?.propertyId}`, item?.bidCenterAlertDetails?.propertyCategory, item?.bidCenterAlertDetails?.propertyStatus)}>

                                                                    <div className="outbid-image">
                                                                        <img className="img-fluid "
                                                                            style={{ height: '100%', width: '100%' }}
                                                                            src={imageOnTheWay}
                                                                            alt="imgOnTheWay" />

                                                                        {item?.favouritedProperty &&

                                                                            <div className="fav-icons-outbid">
                                                                                <FaHeart
                                                                                    color={item?.favouritedProperty ? "#ff5a5f" : "#888D91"}
                                                                                    className="cursor-pointer"
                                                                                    size={18} />
                                                                            </div>}

                                                                    </div>

                                                                </Card>
                                                            </Col>
                                                            <Col xs={12} md={8}>
                                                                <Row xs={12} md={12} className="d-flex align-items-start">
                                                                    {/* <Col  md={12} > */}
                                                                    <Col xs={12} md={5} className="d-flex align-items-start">

                                                                        <div className="">
                                                                            <p className="smallFont">{endTheAuctionNowTapped ? "End the auction now" : "Bid Amount"}  </p>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={12} md={7} className="d-flex align-items-start">

                                                                        <div
                                                                            className="col-md-3"
                                                                            style={{
                                                                                width: "80px",
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className="d-flex align-items-center justify-content-around "
                                                                                style={{
                                                                                    // border: "2px solid green",
                                                                                }}
                                                                            >
                                                                                <button
                                                                                    id="alert-bid-decrement-btn"
                                                                                    type=""
                                                                                    className="bidDecBtn"
                                                                                    data-bs-toggle=""
                                                                                    onClick={() => {
                                                                                        { !endTheAuctionNowTapped ? handleDecrement() : null; }
                                                                                    }}>

                                                                                    -
                                                                                </button>
                                                                                <input style={{ width: 70 }}
                                                                                    type=""
                                                                                    className="bidAmountInput"
                                                                                    id="alert-bid-amount-input"
                                                                                    disabled={endTheAuctionNowTapped ? true : false}
                                                                                    onChange={getAmountDetailsData}
                                                                                    onBlur={() => {
                                                                                        validateBidMinMaxPrice();
                                                                                    }}
                                                                                    value={buyerAmountInfo?.bidAmountFormatted ? buyerAmountInfo?.bidAmountFormatted : ("$" + item?.bidCenterAlertDetail?.formattedNextpossibleBidAmount)} />
                                                                                <button
                                                                                    id="alert-bid-increment-btn"
                                                                                    type=""
                                                                                    className="bidIncBtn"
                                                                                    data-bs-toggle=""
                                                                                    disabled={endTheAuctionNowTapped ? true : false}
                                                                                    onClick={() => {
                                                                                        handleIncrement();
                                                                                    }}>


                                                                                    +
                                                                                </button>
                                                                            </div>
                                                                        </div>


                                                                    </Col>
                                                                    {/* </Col> */}


                                                                </Row>


                                                                {buyerAmountInfo?.buyerPremiumPercentage !== null && parseInt(buyerAmountInfo?.buyerPremiumPercentage) !== 0 &&
                                                                    <Row xs={12} md={12} className="d-flex align-items-start">
                                                                        <Divider style={{ fontSize: 10, width: "90%" }}></Divider>
                                                                        {/* <Col  md={12} > */}
                                                                        <Col xs={12} md={6} className="d-flex align-items-start">
                                                                            {bidCenterDetails?.propertyCategory === 'COMMERCIAL' ?
                                                                                <div className="">
                                                                                    <p className="smallFont">Transaction Fee {(buyerAmountInfo?.buyerPremiumPercentage !== null && buyerAmountInfo?.buyerPremiumPercentage?.length !== 0 && buyerAmountInfo?.buyerPremiumPercentage !== undefined) ? "(" + buyerAmountInfo?.buyerPremiumPercentage + "%)" : ""}</p>
                                                                                </div>
                                                                                :
                                                                                <div className="">
                                                                                    <p className="smallFont">Buyer's Premium {(buyerAmountInfo?.buyerPremiumPercentage !== null && buyerAmountInfo?.buyerPremiumPercentage?.length !== 0 && buyerAmountInfo?.buyerPremiumPercentage !== undefined) ? "(" + buyerAmountInfo?.buyerPremiumPercentage + "%)" : ""}</p>
                                                                                </div>}

                                                                        </Col>
                                                                        <Col xs={12} md={6} className="smallFont d-flex align-items-start">
                                                                            {buyerAmountInfo?.buyerPremiumFormatted ? buyerAmountInfo?.buyerPremiumFormatted : ''}

                                                                        </Col>
                                                                        {/* </Col> */}


                                                                    </Row>
                                                                }

                                                                <Row xs={12} md={12} className="d-flex align-items-start">
                                                                    <Divider style={{ fontSize: 20, width: "90%" }}></Divider>
                                                                    {/* <Col  md={12} > */}
                                                                    <Col xs={12} md={6} className="d-flex align-items-start">

                                                                        <div className="">
                                                                            <p className="smallFont">Total Due</p>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={12} md={6} className="smallFont d-flex align-items-start">
                                                                        {buyerAmountInfo?.totalDueFormatted ? buyerAmountInfo?.totalDueFormatted : ''}
                                                                    </Col>
                                                                    {/* </Col> */}


                                                                </Row>



                                                            </Col>
                                                            {validationError?.length > 0 &&
                                                                (
                                                                    <Row>
                                                                        <p className='errorTxt'>{validationError}</p>
                                                                    </Row>
                                                                )}

                                                        </Row></>
                                            }


                                            {(endTheAuctionNowTapped === false && shouldShowAutoBid()) &&
                                                <div className="autoBidBg" >
                                                    <p className='autoBidTxt'>Don’t let this property slip away!
                                                        <br></br>
                                                        Simplify the auction process with Auto Bidding</p>

                                                    <Row md={12}>
                                                        <Col md={6}>
                                                            <p className='autoBidTxt'>Enable Auto Biding</p>


                                                        </Col>
                                                        <Col md={6}>
                                                            <Switch
                                                                id="alert-autobid-toggle"
                                                                checked={isAutoBidEnabled}
                                                                onChange={handleToggle}
                                                                inputProps={{ 'aria-label': 'Enable auto bidding' }}
                                                                color='primary'

                                                            />
                                                        </Col>


                                                    </Row>

                                                    {isAutoBidEnabled ?
                                                        <>
                                                            <Row md={12}>
                                                                <Col md={6}>
                                                                    <p className='autoBidTxRegt'>Auto Bid Limit</p>


                                                                </Col>
                                                                <Col md={3}>

                                                                    <input className="autoBidInput"
                                                                        id="alert-autobid-amount-input"
                                                                        type=""
                                                                        onChange={getAutobidAmountDetailsData}
                                                                        value={"$" + getFormatPrice(autoBidAmount)}



                                                                    />
                                                                    {autoBidValidationError?.length > 0 &&
                                                                        <p className='errorTxt' style={{ width: 120 }}>{autoBidValidationError}</p>
                                                                    }
                                                                </Col>


                                                            </Row>


                                                            {buyerAmountInfo?.buyerPremiumPercentage !== null && parseInt(buyerAmountInfo?.buyerPremiumPercentage) !== 0 &&
                                                                <Row xs={12} md={12} className="d-flex align-items-start">
                                                                    {/* <Col  md={12} > */}
                                                                    <Col xs={12} md={6} className="d-flex align-items-start">
                                                                        {bidCenterDetails?.propertyCategory === 'COMMERCIAL' ?
                                                                            <div className="">
                                                                                <p className="smallFont">Maximum Transaction fee {(autobidAmountInfo?.buyerPremiumPercentage !== null && buyerAmountInfo?.buyerPremiumPercentage?.length !== 0 && buyerAmountInfo?.buyerPremiumPercentage !== undefined) ? "(" + buyerAmountInfo?.buyerPremiumPercentage + "%)" : ""}</p>
                                                                            </div>
                                                                            :
                                                                            <div className="">
                                                                                <p className="smallFont">Maximum Buyer's Premium {(autobidAmountInfo?.buyerPremiumPercentage !== null && buyerAmountInfo?.buyerPremiumPercentage?.length !== 0 && buyerAmountInfo?.buyerPremiumPercentage !== undefined) ? "(" + buyerAmountInfo?.buyerPremiumPercentage + "%)" : ""}</p>
                                                                            </div>
                                                                        }


                                                                    </Col>
                                                                    <Col xs={12} md={6} className="smallFont d-flex align-items-start">
                                                                        {autobidAmountInfo?.buyerPremiumFormatted ? autobidAmountInfo?.buyerPremiumFormatted : ''}

                                                                    </Col>
                                                                    {/* </Col> */}


                                                                </Row>
                                                            }


                                                            <Row xs={12} md={12} className="d-flex align-items-start">
                                                                {/* <Col  md={12} > */}
                                                                <Col xs={12} md={6} className="d-flex align-items-start">

                                                                    <div className="">
                                                                        <p className="autoBidTxt">Maximum Total Due</p>
                                                                    </div>
                                                                </Col>
                                                                <Col xs={12} md={6} className="autoBidTxt d-flex align-items-start">
                                                                    {autobidAmountInfo?.totalDueFormatted ? autobidAmountInfo?.totalDueFormatted : ''}
                                                                </Col>
                                                                {/* </Col> */}


                                                            </Row>
                                                        </>

                                                        : null
                                                    }

                                                </div>
                                            }



                                            <Row xs={12} md={3} className="d-flex row align-items-center pt10">
                                                <Col xs={8} md={8} >
                                                    <button
                                                        id="alert-confirm-bid-btn"
                                                        className='confirmBidBtn'
                                                        style={{ width: 'auto', fontSize: 14 }}
                                                        onClick={() => {
                                                            setShouldShowError(true);
                                                            confirmBid()
                                                        }}>
                                                        {item.type === 'BACKUP_BID_EXPIRY' ? "Extend Backup Bid" : "Confirm Bid"}

                                                    </button>
                                                </Col>
                                                <Col xs={4} md={4}>
                                                    <Button
                                                        id="alert-edit-bid-details-btn"
                                                        variant="link"
                                                        onClick={handleBidwizarddNavigation}
                                                        style={{
                                                            textDecoration: "none",
                                                            color: "#118BF4",
                                                            padding: "0",
                                                            marginLeft: "16px",
                                                            fontSize: 12,
                                                        }}
                                                    >
                                                        <i className="fas fa-times"></i>Edit bid details
                                                    </Button>
                                                </Col>

                                            </Row>

                                        </div> : <>

                                            {

                                                item.type === "SAVE_SEARCH" ?

                                                    renderSaveSearchAlert()
                                                    :

                                                    <>
                                                        <Row xs={12} md={8} >
                                                            <p className="headerText d-flex align-items-start p0">
                                                                {item.message}
                                                            </p>
                                                        </Row>
                                                        <Row xs={12} md={8} className=" d-flex align-items-start p0">
                                                            {item.type === 'BACKUP_BID_EXPIRY' ? (
                                                                <p className="recentBidTxt d-flex align-items-start p0">
                                                                    {"  Extend your backup bid to continue participating in this auction."}
                                                                </p>
                                                            ) :
                                                                item?.type === 'DRIVEN_BID_WATCHER_ALERT' ?
                                                                    <p className="recentBidTxt d-flex align-items-start p0" style={{ width: "90%" }}>
                                                                        {"An opening bid was just placed for the below property. Don't let it get away."}
                                                                    </p>
                                                                    :
                                                                    <p className="recentBidTxt d-flex align-items-start p0">
                                                                        {"Your most recent bid was $" + item.formattedLastBidAmount}
                                                                    </p>
                                                            }

                                                        </Row>
                                                        <Row className="mb-4">
                                                            <Col md={4} style={{ paddingLeft: 0 }}>
                                                                <Card style={{ height: 100 }}
                                                                id="alert-backup-bid-property-card"
                                                                    className="pointer"
                                                                    onClick={() => navigateToProperty(`/property/${item?.propertyId}`, item?.bidCenterAlertDetails?.propertyCategory, item?.bidCenterAlertDetails?.propertyStatus)}>

                                                                    <div className="outbid-image">
                                                                        <img className="img-fluid "
                                                                            style={{ height: '100%', width: '100%' }}
                                                                            src={imageOnTheWay}
                                                                            alt="imgOnTheWay"
                                                                        />

                                                                        {
                                                                            item?.favouritedProperty &&

                                                                            <div className="fav-icons-outbid">
                                                                                <FaHeart
                                                                                    color={item?.favouritedProperty ? "#ff5a5f" : "#888D91"}
                                                                                    className="cursor-pointer"
                                                                                    size={18}
                                                                                />
                                                                            </div>

                                                                        }

                                                                    </div>
                                                                    {/* <span style={{ zIndex: 2 }}><FaHeart color="#ff5a5f" size={25}/> </span>

                                            <img className="img-fluid "
                                                style={{ height: '100%', width: '100%' }}
                                                src={imageOnTheWay}
                                                alt="" /> */}

                                                                </Card>
                                                            </Col>
                                                            <Col xs={12} md={8}>
                                                                <Row xs={12} md={8} className="d-flex align-items-start">
                                                                    {/* <Col  md={12} > */}
                                                                    <Col xs={12} md={4} className="d-flex align-items-start">
                                                                        {item.type === 'BACKUPBID' ||
                                                                            item.type === 'BACKUP_BID_EXPIRY' ? (
                                                                            <>

                                                                            </>
                                                                        ) : (
                                                                            <div className="">
                                                                                <h4 className="amountTxt mb-0 fw-bold ">
                                                                                    {"$" + item.bidCenterAlertDetails?.formattedCurrentHighestBid}
                                                                                </h4>

                                                                            </div>
                                                                        )} </Col>
                                                                    <Col xs={12} md={4} className="d-flex align-items-start">
                                                                        {item?.bidCenterAlertDetails?.auctionTimeLeft != null && item?.bidCenterAlertDetails?.auctionTimeLeft !== 0 && (
                                                                            <Counter
                                                                                until={
                                                                                    item?.bidCenterAlertDetails
                                                                                        ? item?.bidCenterAlertDetails?.auctionTimeLeft / 1000
                                                                                        : null
                                                                                }
                                                                            />
                                                                        )}
                                                                    </Col>
                                                                    {/* </Col> */}
                                                                    <div id="alert-property-address" className="address-details pt10 pointer"
                                                                        onClick={() => {
                                                                            trackButtonClick({
                                                                                eventName: `global_alerts_location_click`,
                                                                                eventCategory: "Global Alerts",
                                                                                eventSource: `On Edit bid details click`,
                                                                                eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | PageName: ${getEventCategory()}`
                                                                            })
                                                                            navigateToProperty(`/property/${item?.propertyId}`, item?.bidCenterAlertDetails?.propertyCategory, item?.bidCenterAlertDetails?.propertyStatus);
                                                                        }}>
                                                                        <p className="addressText mb-0">
                                                                            {(item?.propertyAddress?.streetNumber || "") + " " + (item?.propertyAddress?.streetName || "")}
                                                                        </p>

                                                                    </div>

                                                                </Row>


                                                                <Row xs={12} md={3} className="d-flex row align-items-center pt10">
                                                                    <button
                                                                        id="alert-place-bid-btn"
                                                                        variant=""
                                                                        className='solidBtn'
                                                                        style={{ width: '48%' }}
                                                                        onClick={() => {
                                                                            // dispatch(resetBidWizard());

                                                                            if (item.type === 'BACKUP_BID_EXPIRY') {

                                                                                handlePlaceBid();


                                                                            } else {
                                                                                if(item?.type === 'DRIVEN_BID_WATCHER_ALERT'){
                                                                                    navigateToProperty(`/property/${item?.propertyId}`, item?.bidCenterAlertDetails?.propertyCategory, item?.bidCenterAlertDetails?.propertyStatus);

                                                                                }else{
                                                                                    handlePlaceBid();
                                                                                }


                                                                            }
                                                                        }}
                                                                    >

                                                                        {isProcessing ? (
                                                                            <LoadingText text="Processing..." />
                                                                        ) : (
                                                                            <LoadedText text={item.type === 'BACKUPBID'
                                                                                ? 'Update Backup Bid'
                                                                                : item.type === 'BACKUP_BID_EXPIRY'
                                                                                    ? 'Extend Backup Bid'
                                                                                    : 'Place Bid'} />
                                                                        )}

                                                                    </button>
                                                                    {!viewDetailsTapped &&
                                                                        <button
                                                                            id="alert-view-details-btn"
                                                                            variant=''
                                                                            style={{ width: '48%' }}
                                                                            className="detailsBtn"
                                                                            onClick={() => {
                                                                                setViewDetailsTapped(true)
                                                                                trackButtonClick({
                                                                                    eventName: "global_alerts_view_details",
                                                                                    eventCategory: "Global Alerts",
                                                                                    eventSource: "on view details button click",
                                                                                    eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | highestBidAmount: ${item?.bidCenterAlertDetails?.currentHighestBid} | PageName: ${getEventCategory()}`,
                                                                                })
                                                                            }}
                                                                        >
                                                                            {'View Details'}
                                                                            {/* {componentType === "offers" ? "Offer Details" : "Bid Details"} */}
                                                                        </button>



                                                                    }

                                                                    <br />
                                                                    {/* {componentType !== "offers" && (
                                        <Button variant='link' className="text-decoration-none">
                                            Bid History
                                        </Button>
                                    )} */}
                                                                </Row>

                                                                {item?.buyItNowPrice !== null &&
                                                                    item?.specialFeatures?.length > 0 && item?.specialFeatures[0] === 'OWN_IT_NOW_ENABLED' &&
                                                                    (
                                                                        <div className='pt15'>
                                                                            <Divider style={{ fontSize: 10 }}>OR</Divider>

                                                                            <Row xs={12} md={3} className="d-flex row align-items-center pt10">
                                                                                <button
                                                                                    id="alert-end-auction-now-btn"
                                                                                    variant='secondary'
                                                                                    style={{ width: '55%' }}
                                                                                    className="solidBtn"
                                                                                    onClick={() => endTheAuctionNow(true)}
                                                                                >
                                                                                    {'End the Auction now'}

                                                                                    {/* {componentType === "offers" ? "Offer Details" : "Bid Details"} */}
                                                                                </button>
                                                                                <p className='detailText'
                                                                                    style={{ width: "auto" }}

                                                                                >
                                                                                    For ${item?.buyItNowPrice}
                                                                                    {/* {componentType === "offers" ? "Offer Details" : "Bid Details"} */}
                                                                                </p>
                                                                                <br />
                                                                                {/* {componentType !== "offers" && (
                                        <Button variant='link' className="text-decoration-none">
                                            Bid History
                                        </Button>
                                    )} */}
                                                                            </Row>
                                                                        </div>
                                                                    )}
                                                            </Col>

                                                        </Row>
                                                        {viewDetailsTapped &&
                                                            <Row>
                                                                <div className="row update-license-actions">
                                                                    <div className="col-10 license-error-message license-error-rtD6fUABSu">

                                                                    </div>
                                                                    <div className="col-2">

                                                                        <Button id="alert-close-details-btn" style={{ padding: 0 }}
                                                                            onClick={() => {
                                                                                setViewDetailsTapped(false);
                                                                                trackButtonClick({
                                                                                    eventName: "global_alerts_close_details",
                                                                                    eventCategory: "Global Alerts",
                                                                                    eventSource: "on close details button click",
                                                                                    eventLabel: `listingId: ${item.listingId} | Message Id: ${messageId} | highestBidAmount: ${item?.bidCenterAlertDetails?.currentHighestBid} | PageName: ${getEventCategory()}`,
                                                                                })
                                                                            }}
                                                                            variant="outlined"
                                                                        >
                                                                            <IoMdClose size={12} />
                                                                        </Button>
                                                                    </div>
                                                                </div>

                                                                {
                                                                    item?.formattedLastBidAmount &&

                                                                    <Row xs={12} md={12} className="d-flex align-items-start">
                                                                        <Divider style={{ fontSize: 10, width: "90%" }} ></Divider>
                                                                        {/* <Col  md={12} > */}
                                                                        <Col xs={12} md={4} className="d-flex align-items-start">

                                                                            <div className="">
                                                                                <p className="mircoFont">Your Last Bid</p>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={12} md={4} className="d-flex align-items-start">

                                                                            <div className="">
                                                                                <p className="mircoFont">{"$" + item?.formattedLastBidAmount}</p>
                                                                            </div>
                                                                        </Col>
                                                                        <Col xs={12} md={4} className="d-flex align-items-start">


                                                                            {/* {(item?.bidCenterAlertDetails?.reservePriceEnabled === "Y" && auctionDetails?.reservePriceMet === 'Y') && */}
                                                                            {auctionDetails?.reservePriceMet === 'Y' &&
                                                                                <><SiTicktick color='#30c844' /><p
                                                                                    className="reserveMetTxt" style={{ paddingLeft: 2, paddingTop: 2 }}>Reserve Met</p></>

                                                                                //  <p className="mircoFont">Reserve Not Met</p>
                                                                            }

                                                                        </Col>
                                                                        {/* </Col> */}


                                                                    </Row>

                                                                }


                                                                <Row xs={12} md={12} className="d-flex align-items-start">
                                                                    <Divider style={{ fontSize: 10, width: "90%" }} ></Divider>
                                                                    {/* <Col  md={12} > */}
                                                                    <Col xs={12} md={4} className="d-flex align-items-start">

                                                                        <div className="">
                                                                            <p className="mircoFont">Current Hightest Bid</p>
                                                                        </div>
                                                                    </Col>

                                                                    <Col xs={12} md={4} className="d-flex align-items-start">

                                                                        <div className="">
                                                                            <p className="mircoFont">{"$" + bidCenterDetails?.formattedCurrentHighestBid}</p>
                                                                        </div>
                                                                    </Col>
                                                                    <Col xs={12} md={4} className="mircoFont d-flex align-items-start">
                                                                        {auctionDetails?.numberOfBids !== undefined ? auctionDetails?.numberOfBids + " Bids" : 0 + " Bids"}

                                                                    </Col>
                                                                    {/* </Col> */}


                                                                </Row>

                                                                <Row>
                                                                    <Row xs={12} md={12} className="d-flex align-items-start">
                                                                        <Divider style={{ fontSize: 10, width: "90%" }} ></Divider>
                                                                        {/* <Col  md={12} > */}
                                                                        <Col xs={12} md={3} className="smallFont d-flex align-items-start">

                                                                            <div className="">
                                                                                <p className="timerFont m0 ">{getDHM(futureDate)?.days + " Days"}</p>
                                                                                <p className="mircoFont">Time Left</p>
                                                                            </div>
                                                                        </Col>

                                                                        <Col xs={12} md={3} className="mircoFont d-flex align-items-start">
                                                                            <div className="">
                                                                                <LiaBedSolid size={25} />

                                                                                <p className="mircoFont">{item?.bedCount + " Beds"}</p>
                                                                            </div>


                                                                        </Col>
                                                                        <Col xs={12} md={3} className="mircoFont d-flex align-items-start">
                                                                            <div className="">
                                                                                <LuBath size={25} />

                                                                                <p className="mircoFont">{item?.bathCount + " Baths"}</p>
                                                                            </div>

                                                                        </Col>
                                                                        <Col xs={12} md={3} className="mircoFont d-flex align-items-start">
                                                                            <div className="">
                                                                                <BiRuler size={25} />
                                                                                <p className="mircoFont">{getFormatPrice(item?.areaSqurFeet) + " Sq.Ft"}</p>
                                                                            </div>

                                                                        </Col>
                                                                        {/* </Col> */}


                                                                    </Row>
                                                                </Row>
                                                            </Row>


                                                        }
                                                    </>

                                            }

                                        </>
                                }
                                {/* {AlertsList.map((item, index) => ( */}



                            </>
                    }
                </Container>
            </div>
        </div>
    )

};

export default AlertsCards;

